import { FlightTurnaroundDto, ResourceType } from '../../../../../backend';
import { resourceFields } from '../gantt.utils';

//allocate the selected resource to the turnaround
//when the selected resource is null (=deallocation), set resource to '' to send the information to atm-data
export const allocateTurnaround = (
    turnaround: FlightTurnaroundDto,
    resourceName: string,
    resourceType: ResourceType,
) => {
    const newResource = resourceName || '';

    if (resourceType === ResourceType.PARKING) {
        const isBothFlightsAndShareParkingAndNoTowings =
            !!turnaround.arrivalFlight &&
            !!turnaround.departureFlight &&
            (!turnaround.arrivalFlight.towings || turnaround.arrivalFlight.towings.length === 0) &&
            turnaround.arrivalFlight.arrivalParking === turnaround.departureFlight.departureParking;
        const isBothFlightsAndArrivalTowings =
            !!turnaround.arrivalFlight &&
            !!turnaround.departureFlight &&
            !!turnaround.arrivalFlight.towings &&
            turnaround.arrivalFlight.towings.length > 0;
        const allocateBoth = isBothFlightsAndShareParkingAndNoTowings && turnaround.considerArrivalFlight;
        const allocateArrival =
            allocateBoth ||
            (!isBothFlightsAndShareParkingAndNoTowings && turnaround.considerArrivalFlight) ||
            (isBothFlightsAndArrivalTowings && turnaround.considerArrivalFlight);
        const allocateDeparture =
            allocateBoth ||
            (isBothFlightsAndShareParkingAndNoTowings &&
                !turnaround.considerArrivalFlight &&
                turnaround.considerDepartureFlight) ||
            (!isBothFlightsAndShareParkingAndNoTowings && turnaround.considerDepartureFlight) ||
            (isBothFlightsAndArrivalTowings && turnaround.considerDepartureFlight);

        const newTowings =
            isBothFlightsAndArrivalTowings && !turnaround.considerArrivalFlight && turnaround.considerDepartureFlight
                ? turnaround.arrivalFlight.towings.map((towing, index) => {
                      if (index === turnaround.arrivalFlight.towings.length - 1) {
                          return {
                              ...towing,
                              parking: newResource,
                          };
                      } else {
                          return towing;
                      }
                  })
                : turnaround.arrivalFlight?.towings || [];

        return {
            ...turnaround,
            actualOccupation: {
                ...turnaround.actualOccupation,
                resource: newResource,
            },
            ...(turnaround?.arrivalFlight
                ? {
                      arrivalFlight: {
                          ...turnaround.arrivalFlight,
                          arrivalParking: allocateArrival ? newResource : turnaround.arrivalFlight.arrivalParking,
                          towings: newTowings,
                      },
                  }
                : { arrivalFlight: turnaround?.arrivalFlight }),
            ...(turnaround?.departureFlight
                ? {
                      departureFlight: {
                          ...turnaround.departureFlight,
                          departureParking: allocateDeparture
                              ? newResource
                              : turnaround.departureFlight.departureParking,
                      },
                  }
                : { departureFlight: turnaround?.departureFlight }),
        } as FlightTurnaroundDto;
    } else {
        return {
            ...turnaround,
            actualOccupation: {
                ...turnaround.actualOccupation,
                resource: newResource,
            },
            ...(turnaround?.considerArrivalFlight && turnaround?.arrivalFlight
                ? {
                      arrivalFlight: {
                          ...turnaround.arrivalFlight,
                          [resourceFields[resourceType].arrival]: newResource,
                      },
                  }
                : { arrivalFlight: turnaround?.arrivalFlight }),
            ...(turnaround?.considerDepartureFlight && turnaround?.departureFlight
                ? {
                      departureFlight: {
                          ...turnaround.departureFlight,
                          [resourceFields[resourceType].departure]: newResource,
                      },
                  }
                : { departureFlight: turnaround?.departureFlight }),
        } as FlightTurnaroundDto;
    }
};
